import OrderHandler from "../OrderHandler";
import ItemCategory from "../../../Models/ItemCategory";
import { createImg } from "../../../DomUtilities/ElementsCreator";
import ServiceTile from "./ServiceTile";
import Mediator from "../../../Utilities/Mediator";
import Item from "../../../Models/Item";

export default class ChooseService {
	chooseService: HTMLDivElement;
	stepsWrapper: HTMLDivElement;
	selectedItemTileWrapper: HTMLDivElement;

	constructor() {
		this.stepsWrapper = document.querySelector('.create-order > div');
		this.chooseService = document.createElement('div');

		this.init();
	}

	private init() {
		this.chooseService.classList.add("choose-service");
		this.createServiceTiles();
		this.createSelectedItemTileWrapper();
		Mediator.on("serviceSelected", () => this.removeChooseService());
		Mediator.on("chooseItemDisplayed", () => this.removeChooseService());
	}

	public createServiceTiles() {
		this.chooseService.innerHTML = "";

		const separator = document.createElement('hr');
		const servicesWrapper = document.createElement('div');
		const item = OrderHandler.currentItems.find(i => i.id === OrderHandler.selectedItem.id);
		const serviceSelectAlert = document.createElement("main");

		if (item.hasSimpleOrderFlow) {
			serviceSelectAlert.innerText = this.stepsWrapper.dataset.single;
		} else {
			serviceSelectAlert.innerText = this.stepsWrapper.dataset.multi;
		}

		item.services.sort((s1, s2) => s1.displayOrder - s2.displayOrder);
		this.chooseService.appendChild(separator);
		this.chooseService.appendChild(serviceSelectAlert);

		item.services.forEach(service => {
			const serviceTile = new ServiceTile(service);
			servicesWrapper.appendChild(serviceTile.serviceTile);
		});

		this.chooseService.appendChild(servicesWrapper);
		this.stepsWrapper.appendChild(this.chooseService);
	}

	public createSelectedItemTileWrapper() {
		this.selectedItemTileWrapper = document.createElement('div');
		if (OrderHandler.currentItems.length > 1) {
			OrderHandler.currentItems.forEach(item => {
				const itemTileTab = this.createSelectedItemTile(item);
				this.selectedItemTileWrapper.appendChild(itemTileTab);
				if (OrderHandler.selectedItem.id === item.id) {
					itemTileTab.classList.add("--selected");
				}

				this.addSelectedItemTileTabClickListener(itemTileTab, item.id);
			});
		} else {
			this.selectedItemTileWrapper.appendChild(this.createSelectedItemTile(OrderHandler.selectedItem));
		}
		this.stepsWrapper.appendChild(this.selectedItemTileWrapper);
	}

	private createSelectedItemTile(item: ItemCategory): HTMLDivElement {
		const src: string = item.image ? item.image : "/assets/no_image_placeholder.png";
		const itemTile = document.createElement('div');
		const icon = createImg(src, `${item.name} ikon`);

		itemTile.id = item.itemId;
		itemTile.title = item.name;
		const selectedItemTopClass: string = OrderHandler.items.find(i => i.isFastTrack) ? "selected-item--fast-track-simple" : "selected-item--no-fast-track-simple";
		itemTile.classList.add("selected-item", selectedItemTopClass);
		itemTile.appendChild(icon);

		return itemTile;
	}

	private addSelectedItemTileTabClickListener(itemTileTab: HTMLDivElement, itemId: string) {
		itemTileTab.onclick = () => {
			Array.from(this.selectedItemTileWrapper.children).forEach(tile => tile.classList.remove("--selected"));
			itemTileTab.classList.add("--selected");
			this.setSelectedItem(itemId, itemTileTab.id);
			this.createServiceTiles();
		}
	}

	private setSelectedItem(id: string, itemId: string) {
		const itemCategory: ItemCategory = OrderHandler.currentItems.find(i => i.id === id);
		const item = new ItemCategory();
		item.id = id;
		item.itemId = itemId;
		item.name = itemCategory.name;
		item.image = itemCategory.image;
		item.hasSimpleOrderFlow = itemCategory.hasSimpleOrderFlow;

		const savedItem: Item = OrderHandler.order.items.find(i => i.itemId === itemId);
		if (savedItem) {
			item.services = savedItem.services;
		}

		OrderHandler.selectedItem = item;
	}

	private removeChooseService() {
		this.chooseService.remove();
		this.selectedItemTileWrapper.remove();
	}
}
